import { CommandType } from '@iot-platform/models/i4b';
import { I4BCellType } from '../configurations';
import { I4bCellConcept } from '../enums';
import { HeaderType } from '../models';
import { I4BButtonColumn } from './i4b-button.column';

export class BamDeviceButtonColumn extends I4BButtonColumn {
  constructor() {
    super(
      {
        type: HeaderType.CALL_TO_ACTION,
        displayName: 'BUTTON',
        icon: ''
      },
      {
        concept: I4bCellConcept.DEVICES,
        isConfigurable: false,
        isDefault: true,
        isLink: false,
        position: '',
        sortProperty: '',
        width: 10,
        id: 'button',
        cell: {
          type: I4BCellType.CALL_TO_ACTION,
          bulkActions: [
            {
              order: 1,
              key: 'bulk_edit_devices',
              label: 'DEVICES.INFO_FORM_POPUP.EDIT_DEVICES',
              enableConditions: [[{ key: 'canUpdateDevice', value: true }]],
              disableConditions: [],
              visibleConditions: []
            },
            {
              order: 2,
              key: 'bulk_apply_template',
              label: 'DEVICES.DETAIL_DEVICE_CARD.IMPORT_FORM_TEMPLATE',
              enableConditions: [[{ key: 'canUpdateDevice', value: true }]],
              disableConditions: [],
              visibleConditions: []
            },
            {
              order: 3,
              key: `bulk_${CommandType.REFRESH}_command`,
              label: `DEVICES.DETAIL_DEVICE_CARD.${CommandType.REFRESH}`,
              enableConditions: [[{ key: 'canReadDevice', value: true }]],
              disableConditions: [],
              visibleConditions: [],
              divider: true
            }
          ],
          singleActions: [
            {
              order: 0,
              key: 'apply_template',
              label: 'DEVICES.DETAIL_DEVICE_CARD.IMPORT_FORM_TEMPLATE',
              enableConditions: [[{ key: 'canUpdateDevice', value: true }]],
              disableConditions: [],
              visibleConditions: []
            },
            {
              order: 1,
              divider: true,
              key: CommandType.SELFCONF_CHANNEL_1,
              label: `DEVICES.DETAIL_DEVICE_CARD.${CommandType.SELFCONF_CHANNEL_1}`,
              enableConditions: [[{ key: 'canReadDevice', value: true }]],
              visibleConditions: []
            },
            {
              order: 2,
              key: CommandType.SELFCONF_CHANNEL_2,
              label: `DEVICES.DETAIL_DEVICE_CARD.${CommandType.SELFCONF_CHANNEL_2}`,
              enableConditions: [[{ key: 'canReadDevice', value: true }]],
              visibleConditions: []
            },
            {
              order: 3,
              key: CommandType.SELFCONF_DEVICE,
              label: `DEVICES.DETAIL_DEVICE_CARD.${CommandType.SELFCONF_DEVICE}`,
              enableConditions: [[{ key: 'canReadDevice', value: true }]],
              visibleConditions: []
            },
            {
              order: 4,
              key: CommandType.REFRESH,
              label: `DEVICES.DETAIL_DEVICE_CARD.${CommandType.REFRESH}`,
              divider: true,
              enableConditions: [[{ key: 'canReadDevice', value: true }]],
              disableConditions: [],
              visibleConditions: []
            }
          ],
          visibleConditions: [[{ key: 'canReadDevice', value: true }]],
          enableConditions: []
        }
      },
      { order: 1000 }
    );
  }
}
